import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template"]

  add(event) {
    debugger
    event.preventDefault()
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
    this.containerTarget.insertAdjacentHTML("beforeend", content)
  }

  remove(event) {
    event.preventDefault()
    const button = event.target
    const block = button.closest(".education-block")

    const destroyInput = block.querySelector("input[name*='_destroy']")
    if (destroyInput) {
      destroyInput.value = "1"
      block.style.display = "none"
    } else {
      block.remove()
    }

    this.showSaveNotice(block)
  }

  showSaveNotice(block) {
    let notice =  this.containerTarget.querySelector(".pending-save-warning")
    if (notice) {
      notice.style.display = 'block';
    }
  }
}
